import React, { useState, useEffect } from "react";
import { Input, Pagination, Row, Col, Empty, Spin } from "antd";
import PostCard from "../../components/PostCard";
import { listPosts } from "../../api/mockData";

export default function Home() {
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const pageSize = 12; // 增加每页显示数量

  useEffect(() => {
    const loadPosts = async () => {
      setLoading(true);
      try {
        const result = await listPosts({ page, pageSize, keyword });
        setData({
          items: result.items || [],
          total: result.total || 0
        });
      } catch (error) {
        console.error('Error loading posts:', error);
        setData({ items: [], total: 0 });
      } finally {
        setLoading(false);
      }
    };

    loadPosts();
  }, [page, pageSize, keyword]);

  return (
    <div>
      <div className="page-title" style={{ color: "var(--theme-text)" }}>最新文章</div>

      <div style={{ marginBottom: 20 }}>
        <Input.Search
          allowClear
          placeholder="搜索标题/摘要/正文"
          onSearch={(v) => {
            setKeyword(v || "");
            setPage(1);
          }}
          onChange={(e) => {
            const v = e.target.value;
            setKeyword(v);
            setPage(1);
          }}
          style={{ maxWidth: 400 }}
          // 去掉主题色，使用默认样式
        />
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 50 }}>
          <Spin size="large" />
        </div>
      ) : (!data.items || data.items.length === 0) ? (
        <div className="card-glow" style={{ padding: 40, textAlign: 'center' }}>
          <Empty description="没有匹配的文章" />
        </div>
      ) : (
        <>
          <Row gutter={[20, 20]}>
            {data.items.map((p) => (
              <Col key={p.id} xs={24} sm={12} md={8} lg={6}>
                <PostCard post={p} />
              </Col>
            ))}
          </Row>

          <div style={{ marginTop: 24, display: "flex", justifyContent: "center" }}>
            <Pagination
              current={page}
              pageSize={pageSize}
              total={data.total}
              onChange={(p) => setPage(p)}
              showSizeChanger={false}
            />
          </div>
        </>
      )}
    </div>
  );
}